export { default } from './index.vue';



//////////////////
// WEBPACK FOOTER
// ./~/@dolphinweex/weex-theme/packages/weex-theme-view/index.js
// module id = 125
// module chunks = 0 1